const SELECTORS = {
    desktopAutoPlay: '.js-auto-play-desktop',
    mobileAutoPlay: '.js-auto-play-mobile',
};

function init() {
    if (!window.matchMedia('(max-width: 639px)').matches) {
        [].forEach.call(document.querySelectorAll(SELECTORS.desktopAutoPlay), el => el.play());
    } else {
        [].forEach.call(document.querySelectorAll(SELECTORS.mobileAutoPlay), el => el.play());
    }
}

module.exports = {
    init
}
